const o = "_noRowsContainer_1312j_1", n = "_noRowsIllustration_1312j_8", s = {
  noRowsContainer: o,
  noRowsIllustration: n
};
export {
  s as default,
  o as noRowsContainer,
  n as noRowsIllustration
};
//# sourceMappingURL=index.es2343.js.map
